const filePathPrefix = '/v1/file/download?filepath='
const fileDownloadZHFW = '/v1/file/zhfw/download?filepath='
const fileDownloadPublick = '/v1/file/public/download?filepath='
const fileUploadPublic = '/v1/file/public/upload'
const constants = {
  filePathPrefix,
  fileDownloadZHFW,
  fileDownloadPublick,
  fileUploadPublic
}
export default constants



// WEBPACK FOOTER //
// ./src/utils/constants.js